function cartVariant(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus) {
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(input.value);
      var minQty = parseInt(input.getAttribute('min')) || 1;
      input.value = currentQty + 1;
      var new_line = this.getAttribute('data-line-item');
      var new_qty = input.value;
      updateItem(new_line, new_qty);
    });
  });
  document.querySelectorAll('.ci_minus a').forEach(function(minus) {
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(input.value);
      var minQty = parseInt(input.getAttribute('min')) || 1;
      if(currentQty > minQty){
        input.value = currentQty - 1;
        var newLine = this.getAttribute('data-line-item');
        var newQty = input.value;
        updateItem(newLine, newQty);
      }
    });
  });
  document.querySelectorAll('.cd_variant').forEach(function(cdVariantAdd) {
    cdVariantAdd.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
      let cart_error = cdVariantAdd.closest('.cartitems').querySelector('.cierror');
      let currentid = cdVariantAdd.closest('.cartitems').querySelector('.item-remove').getAttribute('data-line');
      let changevar_id = cdVariantAdd.getAttribute('data-id');
      let item_current_qty = cdVariantAdd.closest('.cartitems').querySelector('.cart_qty').value;
      let formData = {
        'items': [{'id': changevar_id,'quantity': item_current_qty}]
      };
      console.log('formData',formData);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        setTimeout(function(e){
          updateItem(currentid,0);
        },500);
      })
      .catch((error) => {
        console.error('error',error);
        cart_error.text(e.responseJSON.description);
        setTimeout(function(){
          cart_error.text('');
        },2000);
      });
    })
  })
  let cdVariantBox = document.querySelectorAll(".cd_variant_cls");
  let opencdVariantBox = (variantBox) => {variantBox.classList.add("active");}
  let closecdVariantBox = (variantBox) => {variantBox.classList.remove("active");}
  cdVariantBox.forEach((variantBox) => {
    let btn = variantBox.querySelector(".cd_variantbtn");
    if(btn) btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantBox.forEach((box) => {
        if(box !== variantBox){closecdVariantBox(box);}
      });
      if(variantBox.classList.contains("active")){
        closecdVariantBox(variantBox);
      }else{
        opencdVariantBox(variantBox);
      }
    });
  });
  document.querySelectorAll('.grid-select-btn').forEach((gridSelect) => {
    gridSelect.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let activeSize = true;
      document.querySelectorAll('.grid-size-variants li').forEach((size) => {
        if(size.classList.contains('active')) activeSize = false;
      });
      if(activeSize){
        let height = gridSelect.closest('.grid-btm').querySelector('.size_variant').offsetHeight;
        gridSelect.closest('.snippet-product-grid').classList.add('selectSize');
        gridSelect.closest('.snippet-product-grid').querySelector('.grid-top').style.top = '-'+height+'px';
        
      }
    })
  })
  if(document.querySelector('.snippet-product-grid')) document.querySelectorAll('.snippet-product-grid').forEach(function(prodGrid){
    prodGrid.addEventListener('mouseleave', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      prodGrid.classList.remove('selectSize');
      prodGrid.querySelector('.grid-top').style.top = '';
    });
  });
  document.querySelectorAll('.snippet-product-grid').forEach((allGrid) => {
    allGrid.querySelectorAll('.grid-size-variants li').forEach((gridVariant) => {
      gridVariant.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        allGrid.querySelectorAll('.grid-size-variants li').forEach((gridVariant) => {
          gridVariant.classList.remove('active');
        });
        gridVariant.classList.add('active');
        gridVariant.closest('.grid-btm').querySelector('.grid-variant-btns .grid-add-btn').setAttribute('data-id',gridVariant.getAttribute('data-id'));
        gridVariant.closest('.grid-btm').querySelector('.grid-variant-btns').classList.add('active_added_btn');
      })
    })
  })
  document.querySelectorAll('.grid-select-btn').forEach((gridSelect) => {
    gridSelect.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let activeSize = true;
      document.querySelectorAll('.grid-size-variants li').forEach((size) => {
        if(size.classList.contains('active')) activeSize = false;
      });
      if(activeSize){
        let height = gridSelect.closest('.grid-btm').querySelector('.size_variant').offsetHeight;
        gridSelect.closest('.snippet-product-grid').classList.add('selectSize');
        gridSelect.closest('.snippet-product-grid').querySelector('.grid-top').style.top = '-'+height+'px';
      }
    })
  })
  if(document.querySelector('.add_discount')) document.querySelector('.add_discount').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.cd-subtotal').classList.add('active-discount');
  });
}
function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => updateItem(data_line,0));
    });
    let drawerConsider;
    if(document.querySelector('.cd-also-like')){
      drawerConsider = new Swiper(".cd-also-like",{
        slidesPerView: 2,
        loop: false,
        spaceBetween: 4,
        breakpoints: {
         992: {
            slidesPerView: 3,
            spaceBetween: 8,
          },
        }
      });
    }
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector('body').classList.toggle('open-drawer');
        document.querySelector('.cart_popup').innerHTML = '';
        if(document.querySelector('.newsltr-popup')) document.querySelector('.newsltr-popup').style.maxHeight = '';
        document.querySelector('body').classList.remove('open-menu','open-newsltr','open-search','open-sort','open-filter','active-popup','open-currency');
        if(drawerConsider) drawerConsider.update();
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        if(document.querySelector('.newsltr-popup')) document.querySelector('.newsltr-popup').style.maxHeight = '';
        document.querySelector('body').classList.remove('open-newsltr','active-popup','open-drawer','open-menu','open-search','open-sort','open-filter','open-currency');
      });
    });
    cartVariant();
    quickAddButton();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
        document.querySelectorAll('.cart-count').forEach(function(cartCount){
          if(window.innerWidth > 991){
            cartCount.innerHTML = '('+cart_count+')';
          }else{
            cartCount.innerHTML = cart_count;
          }
        });
      }else{
        document.querySelectorAll('.cart-count').forEach(function(cartCount){
          cartCount.innerHTML = '';
        });
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function updateItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }         
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
if(document.querySelector('.cp_add_discount')) document.querySelector('.cp_add_discount').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelector('.cp-subtotal').classList.add('active-discount');
});
